import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from '@wix/yoshi-flow-editor';
import styles from './responsive-channel-info.scss';
import SubscribeChannelButton, {
  SKINS,
} from '../subscribe-channel-button/subscribe-channel-button';

const TEXTS = ['shared.noVideos', 'shared.oneVideo', 'shared.nVideos'];

class ResponsiveChannelInfo extends React.Component {
  static propTypes = {
    channel: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    onPageRefresh: PropTypes.func,
  };

  renderSubscribeButton = (className, skin) => {
    const { channel, onPageRefresh } = this.props;

    return (
      <SubscribeChannelButton
        channel={channel}
        onPageRefresh={onPageRefresh}
        skin={skin}
        className={className}
      />
    );
  };

  render() {
    const { channel, t } = this.props;
    const { title, videosCount, description } = channel;
    const textIndex = videosCount > 1 ? 2 : videosCount;

    return (
      <div>
        {this.renderSubscribeButton(styles.buttonOnTop)}
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          {this.renderSubscribeButton(
            styles.buttonInDescription,
            SKINS.TRANSPARENT,
          )}
          <div className={styles.count}>
            {t(TEXTS[textIndex], { videosCount })}
          </div>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ResponsiveChannelInfo);
